import { useEffect } from "react";

const GA_MEASUREMENT_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID || "G-Z4CBT8GN2E").trim();

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function Analytics() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!GA_MEASUREMENT_ID) return;

    const { document: doc } = window;
    if (!doc) return;

    const dataLayer = (window.dataLayer = window.dataLayer || []);
    const gtag = (...args: unknown[]) => {
      dataLayer.push(args);
    };
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID, { anonymize_ip: true });

    let cancelled = false;

    const loadScript = () => {
      if (cancelled) return;
      const existing = doc.querySelector(`script[data-gtag='${GA_MEASUREMENT_ID}']`);
      if (existing) return;

      const script = doc.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
      script.setAttribute("data-gtag", GA_MEASUREMENT_ID);
      script.setAttribute("crossorigin", "anonymous");
      doc.head.appendChild(script);
    };

    const schedule = () => {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(() => loadScript(), { timeout: 2000 });
      } else {
        window.setTimeout(loadScript, 1200);
      }
    };

    const onLoad = () => schedule();

    if (doc.readyState === "complete" || doc.readyState === "interactive") {
      schedule();
    } else {
      window.addEventListener("load", onLoad, { once: true });
    }

    return () => {
      cancelled = true;
      window.removeEventListener("load", onLoad);
    };
  }, []);

  return null;
}
